export const MAX_WIDGET_SIZE = 120;

export default {
  MAX_WIDGET_SIZE,
};
